module.exports = __webpack_public_path__ + "img/construction.8f01275d.svg";